export const dataUsuarioVacio = {
  correo: "",
  cedula: "",
  nombres: "",
  apellidos: "",
  sucursal: "",
  errorDescripcion: "",
  cliCodigoCore: "",//agregado cuando se necesito hacer publica la pagina de confirmacion final de pago
  userIsLoggedIn: false,
  isLoadingCompras: false,
  hasErroredCompras: false,
  setDataListaCompras: false,
  clienteFinal: false,
  datosCompras: []
};

export const empresa = "AIGMETROPOLITANA";

export const expresionesRegulares = {
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  stringSinCaracteresEspeciales: /^[^$%'"/:;=<>*|#]*$/,
  razonSocial: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z0-9 _\.&]*$/
}



export const plataformaWeb = "WEB";

///---------Pymes-----------  
export const totales = {
  baseImponible: 0,
  derechoEmision: 0,
  impCampesino: 0,
  iva: 0,
  primaNeta: 0,
  primaTotal: 0,
  superintendencia: 0,
}
export const tipoCotizacion = [
  { name: "Seleccione el tipo", id: "" },
  { name: "Edificio Completo", id: "completo" },
  { name: "Solo áreas comunales", id: "areasComunales" },

]
export const arraySiniestralidad = [
  {
    anio: 0,
    catastrofica: 0,
    noCatastrofica: 0,
    numReclamosC: 0,
    numReclamosNC: 0
  },
  {
    anio: 0,
    catastrofica: 0,
    noCatastrofica: 0,
    numReclamosC: 0,
    numReclamosNC: 0
  },
  {
    anio: 0,
    catastrofica: 0,
    noCatastrofica: 0,
    numReclamosC: 0,
    numReclamosNC: 0
  }
]
export const vehiculoConst = {
  marcaCodigo: '',
  marcaEd: false,
  marcaNombre: '',
  modeloEd: false,
  modeloCodigo: '',
  anioEd: false,
  anio: '',
  modeloNombre: '',
  placa: '',
  placaEd: false,
  motor: '',
  motorEd: false,
  chasis: '',
  chasisEd: false,
  colorCodigo: '',
  colorNombre: '',
  colorEd: false,
  procedenciaCodigo: '',
  procedenciaNombre: '',
  procedenciaEd: false,
  categoriaCodigo: '',
  categoriaEd: false,
  categoriaNombre: '',
}

export const Ramos = {
  rcandina: 'rcandina'
}



// permisos cotizadores
export const PermisosCotizadores = {
  msgSinAcceso: 'Lo sentimos!! El usuario ingresado no tiene permiso para acceder a este apartado.',
  msgSinProductoAuto: 'No se puede continuar con la cotización, por favor borre la cache de su navegador, si el problema persiste contactar con soporte'
}

// Mensajes de error
export const ErrorMsgConstants = {
  duplicidad: 'Actualmente ya existe una poliza con los datos proporcionados para el mismo cliente.',
  errorServicioDuplicidad: 'Ha ocurrido un inconveniente en el servicio que valida la duplicidad. Por favor intente nuevamente.',
  listaNegra: 'Actualmente el cliente seleccionado se encuentra en la lista negra.',
  errorServicioListaNegra: 'Ha ocurrido un inconveniente en el servicio que verifica la lista negra. Por favor intente nuevamente.'
}

// Equivalencias en los ramos
// No se incluye Pymes, ya que tiene varios numeros de ramo, de los cual se escoge 1 de acuerdo al giro de negocio
export const EquiRamos = {
  vehiculos: 21,
  hogar: 26,
  travel: 63,
  rcAndina: 65,
  ap: 25,
  cyberEdge: 49,
  dOExpress: 42,
  rcProfesional: 49,
  rcInstitucional: 49

}



/**
 * Informacion relacionada a los tipos de identificaciones
 */
export const infoIds = {
  codigoCedulaStr: "1",
  codigoRucStr: "2",
  codigoPasaporteStr: "3",
  codigoCedulaNum: 1,
  codigoRucNum: 2,
  codigoPasaporteNum: 3


}

export const TravelAccidentesPersonales = {
  minDias: 50
}


export const IndemnizacionesConfig = {
  // parametro para obtener el url de redirección asignado
  codigoUrlRedireccion: 'principal'


}